/* eslint-disable prefer-const */
import React, { useState, useEffect } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useT } from 'talkr';
import Interval from '../../utils/scripts/interval';
import store from '../../store';
import TextSlider from './textSlider/textSlider';
import SliderReview from './sliderReview/sliderReview';
import logo from './img/logo.png';
import './styles.scss';
import styles from './loader.module.scss';
import GradientSVG from './gradientSVG';
import getLinkToPaymentPage from '../../utils/scripts/getLinkToPaymentPage';
import questions from '../../survey/questions';

let currentInterval;

function Loader() {
  const { T } = useT();
  let [loaderValue, setLoaderValue] = useState(0);
  let [hideClass, setHide] = useState('');
  const mail = questions.getAnswers({ questionName: 'mail' })?.value;
  const age = questions.getAnswers({ questionName: 'age' }).value;
  const idCSS = 'hello';
  let link;

  function runOnFinish() {
    setHide(styles.hide);
  }
  
  useEffect(() => {
    link = getLinkToPaymentPage({ mail, age: age || 'adult' });
    currentInterval = new Interval(() => {
      if (loaderValue >= 100) {
        currentInterval.stop();
        runOnFinish();
        window.location = `${link}`;

        setTimeout(() => {
          store.dispatch({
            type: 'TOGGLE_LOADER',
            payload: false,
          });
        }, 1050);
        return;
      }

      setLoaderValue(++loaderValue);
    }, 120);

    currentInterval.run();
  }, []);

  return (
    <div className={`${styles.container} ${hideClass}`}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.wrapper}>
        <GradientSVG />
        <div className={styles.containerСircle}>
          <CircularProgressbar
            className={styles.loader}
            value={loaderValue}
            maxValue={100}
            text={`${loaderValue}%`}
            strokeWidth={10}
            background
            backgroundPadding={2}
            styles={{
              path: { stroke: `url(#${idCSS})`, height: '100%' },
              background: { fill: '#FFF' },
              trail: { stroke: 'rgba(159, 113, 235, 0.2)' },
              text: { fill: '#303030' },
            }}
          />
        </div>
        <TextSlider />
        <div className={styles.aboutLoaderDescription}>{T('loader_slider_description')}</div>
        <SliderReview />
      </div>
    </div>
  );
}

export default Loader;
